import React, {useState} from 'react';
import ExistingCC from "../../components/pxp/ExistingCC";
import CardRegistration from "../../components/pxp/CardRegistration";
import useGet from "../../hooks/useGet";
import BackLink from "../../components/BackLink";
import { Trans, useLingui } from '@lingui/react/macro';
import { useParams } from 'react-router';

function CardCapturePage(props) {
    const {t} = useLingui();
    return <div className="container mx-auto">
        <div className="mt-4">
            <BackLink to={ t({id: "/precruise/passengers"}) + "/cc"} text={t({id: "back_to_cc_dashboard"})} />
        </div>
        <h1>
            <Trans id="payment_registration">Payment Registration</Trans>
        </h1>
        <div>
            <CardCapture {...props} />
        </div>
    </div>
}

function CardCapture(props) {
    const [replaceExisting, setReplaceExisting] = useState(false);

    const {passengerId} = useParams();
    
    const questionsUrl = `precruise/questions/travelInfo/carddetails/${passengerId}`;
    const data = useGet(questionsUrl, null);


    if(data === null) {
        return <div><span translate="no"><Trans id="loading">loading</Trans>...</span></div>
    }

    if(data?.cardDetails?.cardInfo?.cardNumber && !replaceExisting) {
        return (
            <ExistingCC passengerId={passengerId}
                cardInfo={data.cardDetails.cardInfo}
                replaceCard={() => setReplaceExisting(true)}
            />
        )
    }

    return (
        <CardRegistration
            cardInfo={data?.cardDetails?.cardInfo}
            passengerId={passengerId}
            replaceExisting={replaceExisting}
        />
    );
}

export default CardCapturePage;